<template>
  <div>
    <el-upload
      :action="action"
      :multiple="multiple"

      :file-list="fileList"
      :before-upload="(file, who) => busBeforeUpload(file, name)"
      :limit="limit"
      :on-exceed="(file, fileList) => onExceed(file, fileList)"
      :on-change="(file, fileList) => onChange(file, fileList)"
      :accept="accept || customAccept"
      :class="isAnyTmp ? 'any_file_type' : ''"
      :disabled="disabled"
      :name="name"
      :auto-upload="autoUpload"
      :http-request="httpRequest"
      drag
    >
    <!-- :list-type="listType" -->
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <!-- inner -->
      <!-- <div class="upload_c w_100" >
        <i class="el-icon-plus" />
        <span class="upload_title">{{ uploadTitle }}</span>
      </div> -->

      <!-- hover：模板 -->
      <div
        v-if="!isAnyTmp"
        slot="file"
        slot-scope="{ file }"
        class="upload_item_w"
      >
        <component
          :is="uploadTmp"
          :file="file"
          :file-list="fileList"
          @onRemove="onRemove"
        />
      </div>

      <!-- 上传提示 -->
      <div slot="tip" class="el-upload__tip">
        <UploadTip
          :ref="name"
          :file-max="fileMax"
          :allow-file-type="allowType"
          :tip-text="tip"
        />
      </div>
    </el-upload>

    <!-- 正常：模板 -->
    <component
      :is="uploadTmp"
      v-if="isAnyTmp"
      :file-list="fileList"
      @onRemove="onRemove"
      @onDownload="onDownload"
    />

  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import bus from '@/utils/bus'
import UploadTip from '@/components/public/UploadTip.vue'
import ImageTmp from './imageTmp.vue'
import VideoTmp from './videoTmp.vue'
import ListTmp from './ListTmp.vue'

export default {
  components: {
    UploadTip,
    ImageTmp,
    VideoTmp,
    ListTmp
  },
  props: {
    action:{
      type:String,
      default:''
    },
    httpRequest: {
      type: Function,
      default: () => {}
    },

    multiple: {
      type: Boolean,
      default: true
    },
    autoUpload:{
      type: Boolean,
      default: true
    },
    // oss上传配置
    ossConfig: {
      type: Object,
      default: () => {}
    },
    // 列表集合
    fileList: {
      type: Array,
      default: () => []
    },
    // 上传文件类型（可根据不同类型映射不同模板）
    fileType: {
      type: String,
      default: ''
    },

    listType: {
      type: String,
      default: 'picture-card'
    },

    accept: {
      type: String,
      default: ''
    },
    // 用于后台接收的字段
    name: {
      type: String,
      default: ''
    },
    fileMax: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 0
    },
    tip: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },

    onExceed: {
      type: Function,
      default: () => {}
    },
    onChange: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      beforeUploadRes: null,
      percentage:0,
      isUploading:false,
    }
  },
  computed: {
    customAccept() {
      switch (this.fileType) {
        case 'image':
          return '.jpg,.jpeg,.png,.webp'
        case 'video':
          return '.mp4,.m2v,.mkv,rmvb,.avi,.flv,.mov,.m4v'
        default:
          return ''
      }
    },

    uploadTitle() {
      switch (this.fileType) {
        case 'image':
          return '上传图片'
        case 'video':
          return '上传视频'
        case 'any':
          return '上传附件'
        default:
          return '上传附件'
      }
    },

    // 上传模板
    uploadTmp() {
      switch (this.fileType) {
        case 'image':
          return 'ListTmp'
        case 'video':
          return 'VideoTmp'
        case 'any':
          return 'ListTmp'
        default:
          return 'ListTmp'
      }
    },

    // 允许上传类型
    allowType() {
      const str = this.accept || this.customAccept
      return str
        .replaceAll('.', '')
        .split(',')
        .filter((i) => i)
    },

    isAnyTmp() {
      return true
    }
  },
  mounted(){

  },
  methods: {
    onRemove(file) {
      this.$emit('onRemove', file)
    },

    onDownload(file) {
      this.$emit('onDownload', file)
    },

    // 文件上传之前
    busBeforeUpload(file, who) {
      this.beforeUploadRes = bus.$emit('beforeUpload', file, this.$refs[who])
      return this.beforeUploadRes.uploadPass
    },
  }
}
</script>

<style scoped>
.any_file_type {
   ::v-deep .el-upload-list {
        display: none;
    }
}
/deep/ .el-upload{
  width: 100%;
}
/deep/ .el-upload .el-upload-dragger{
  width: 100%;
}
.upload_c{

}

</style>
